// extracted by mini-css-extract-plugin
export var container = "_99-0";
export var fallback = "_99-5";
export var fallbackIcon = "_99-6";
export var hidden = "_99-2";
export var image = "_99-3";
export var loaded = "_99-4";
export var placeholder = "_99-1";